import React from 'react';

import { Badge, Box, Flex, Paper, PaperProps, Space, Text, useMantineTheme } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { CARD_HEIGHT, CARD_WIDTH } from 'shared/constants/theme';
import { SmartAssistantType } from 'shared/interfaces/SmartAssistant';

interface SmartAssistantTypeCardProps extends PaperProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  type: SmartAssistantType;
  isPreview?: boolean;
  isNew?: boolean;
  isAccessible?: boolean;
}

export function SmartAssistantTypeCard({
  title,
  description,
  icon,
  type,
  isPreview = false,
  isNew = false,
  isAccessible = true,
  ...paperProps
}: SmartAssistantTypeCardProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useMantineTheme();

  return (
    <Paper
      p={16}
      pr={0}
      withBorder
      w={CARD_WIDTH}
      h={CARD_HEIGHT}
      className={isPreview || !isAccessible ? undefined : 'g-hover-style'}
      sx={{
        position: 'relative',
        '&:hover': {
          cursor: isAccessible ? (isPreview ? 'default' : 'pointer') : 'not-allowed'
        },
        opacity: isAccessible ? 1 : 0.8
      }}
      {...paperProps}
      onClick={() =>
        isPreview || !isAccessible ? null : navigate(`${ROUTE_LINKS.createSmartAssistant}?type=${type}`)
      }>
      <Flex direction="row" justify="space-between" align="start" w="100%" h="100%">
        <Flex direction="row" align="start">
          <Box>{icon}</Box>
          <Space w={15} />
          <Flex direction="column" pr={16} gap={5}>
            <Text fz="md" fw={500}>
              {title}
            </Text>
            <Text size="sm" color={theme.other.text.dimmed}>
              {description}
            </Text>
          </Flex>
        </Flex>
      </Flex>

      {isAccessible && isNew && (
        <Badge style={{ position: 'absolute', right: 6, top: -10 }} color="red" tt="capitalize">
          {t('APP.ACTIONS.NEW')}
        </Badge>
      )}
      {isAccessible && isPreview && (
        <Badge style={{ position: 'absolute', right: 6, top: -10 }} color="grape" tt="capitalize">
          {t('APP.COMMING_SOON')}
        </Badge>
      )}
      {!isAccessible && (
        <Badge
          style={{ position: 'absolute', right: 6, top: -10 }}
          color="gray.6"
          leftSection={<IconLock style={{ marginTop: 4, width: 14, height: 14 }} />}
          tt="capitalize">
          {t('APP.ACTIONS.UPGRADE_PLAN')}
        </Badge>
      )}
    </Paper>
  );
}
